import { render, staticRenderFns } from "./FacebookPageAdPostList.vue?vue&type=template&id=218fca26"
import script from "./FacebookPageAdPostList.vue?vue&type=script&lang=js"
export * from "./FacebookPageAdPostList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports